// The banner every staff screen that could reach a candidate shows while the
// school's candidate messages are paused. Staff-facing words only.
import React from 'react';
import { Link } from 'react-router-dom';
import { PauseCircle } from 'lucide-react';

export const HOLD_BANNER_TEXT =
  'Candidate messages after application are paused. Nothing is sent to candidates — no shortlisting, test links, invitations, reminders, rejections or offers.';

export default function MessagingHoldBanner({ paused, loading, showLink = true, className = '' }) {
  if (loading || !paused) return null;
  return (
    <div
      role="status"
      className={`flex items-start gap-3 rounded-lg border border-orange-300 bg-orange-50 px-4 py-3 text-sm text-gray-900 ${className}`}
    >
      <PauseCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-orange-600" aria-hidden="true" />
      <div>
        <p className="font-semibold">{HOLD_BANNER_TEXT}</p>
        <p className="mt-1 text-gray-700">
          Application confirmations and fee reminders still go. Candidates marked as test candidates go through, so a trial job can be run end to end.
          {showLink && (
            <>
              {' '}
              <Link to="/messages?view=campaigns" className="font-medium text-orange-700 underline hover:text-orange-800">
                Messages → Communications
              </Link>
            </>
          )}
        </p>
      </div>
    </div>
  );
}
